<template>
	<!-- App.vue -->

	<v-app>
		<Navigation v-if="token" :mini="drawerMini" />
		<TopBar v-model="drawerMini" />

		<!-- Sizes your content based upon application components -->
		<v-main>
			<!-- Provides the application the proper gutter -->
			<v-container fluid>
				<transition name="router-anim" enter-active-class="animated fadeIn" leave-active-class="">
					<router-view></router-view>
				</transition>
			</v-container>
		</v-main>

		<v-footer app>
			<!-- -->
		</v-footer>
	</v-app>
</template>

<script>
import Navigation from './views/Navigation';
import TopBar from './views/TopBar';
import { mapState, mapActions } from 'vuex';

export default {
	name: 'App',

	components: {
		Navigation,
		TopBar,
	},
	data: () => ({
		group: null,
		drawerMini: false,
	}),
	computed: {
		...mapState({
			token: state => state.auth.token,
		}),
	},
	methods: {
		...mapActions({
			getLocalStorage: 'auth/getLocalStorage',
			load: 'load',
		}),
	},
	beforeMount: function() {
		this.load();
	},
};
</script>
